import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import styled from 'styled-components';
import { useSiteSettings } from '../../hooks/useSiteSettings';

const FloatingContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 999;
`;

const WhatsAppButton = styled.a`
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  transition: transform 0.2s ease, background-color 0.2s ease;
  text-decoration: none;

  &:hover {
    background-color: #1ebe5b;
    transform: scale(1.05);
  }

  @media (min-width: 768px) {
    width: 56px;
    height: 56px;
    font-size: 26px;
  }
`;

const PhoneButton = styled.a`
  background-color: #1a73e8;
  color: white;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  transition: transform 0.2s ease, background-color 0.2s ease;
  text-decoration: none;

  &:hover {
    background-color: #1557b0;
    transform: scale(1.05);
  }

  @media (min-width: 768px) {
    width: 56px;
    height: 56px;
    font-size: 22px;
  }
`;

export const FloatingWhatsApp = () => {
  const { settings } = useSiteSettings();
  const whatsapp = settings?.socialMedia?.whatsapp;

  if (!whatsapp) return null;

  const phoneNumber = whatsapp.replace(/[^0-9]/g, '');

  return (
    <FloatingContainer>
      <PhoneButton
        href={`tel:+${phoneNumber}`}
        aria-label="Telefon"
      >
        <FaPhone />
      </PhoneButton>

      <WhatsAppButton
        href={`https://wa.me/${phoneNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </WhatsAppButton>
    </FloatingContainer>
  );
};
